import fetchUnlistedLands from '#/repository/fetch-unlisted-lands';
import {useQuery} from '@tanstack/react-query';

export const useUnlistedLands = (enabled = true) =>
  useQuery({queryKey: ['unlisted_lands'], queryFn: fetchUnlistedLands, enabled});
